import { ImageBox, type ImageBoxProps } from '../ImageBox';
import {
  UploadImageButton,
  type UploadImageButtonProps,
} from '../UploadImageButton';
import { InputBox, type InputBoxProps } from './InputBox';

export interface ImageInputProps
  extends ImageBoxProps,
    Pick<InputBoxProps, 'state'> {
  onChange?: UploadImageButtonProps['onUploadSuccess'];
  onError?: (message: string) => void;
}

export const ImageInput = ({
  state,
  onChange,
  onError,
  ...props
}: ImageInputProps) => {
  return (
    <InputBox state={state}>
      <div className="p-4 flex items-center gap-5">
        <ImageBox {...props} />
        <UploadImageButton
          label="Change image"
          onUploadError={() => onError?.('Failed to upload image.')}
          onUploadSuccess={onChange}
        />
      </div>
    </InputBox>
  );
};
